const Currency = [
  {
    id: 'KES',
    name: 'KES',
  },
  {
    id: 'UGX',
    name: 'UGX',
  },
  {
    id: 'USD',
    name: 'USD',
  },
  {
    id: 'EUR',
    name: 'EUR',
  },
];

export default Currency;
